import {
  BROADCAST_SET_ATTENDEE_TILE,
  BROADCAST_SET_MIXER_TILE
} from '../Types';

function setAttendeeTile(tileState) {
  return (dispatch, getState) => {
    const {
      meeting: { mixerAttendeeIds }
    } = getState();

    let type = BROADCAST_SET_ATTENDEE_TILE;
    //We use .inlcudes instead of strict equality because it turns out the Chime SDK sets the ID
    //with a suffix to indicate if it is a content stream (rather than video):
    //Example boundAttendeeId: 7bfa1971-3401-482c-a17e-e69afcf3303f#content

    const isMixer = mixerAttendeeIds?.some(mixerAttendeeId =>
      tileState.boundAttendeeId.includes(mixerAttendeeId)
    );

    if (mixerAttendeeIds && isMixer) {
      type = BROADCAST_SET_MIXER_TILE;
    }

    const action = {
      type,
      payload: tileState
    };

    dispatch(action);
  };
}

export default setAttendeeTile;
